import {styles, Text} from '../../tmwx-design-web/src';
import ModuleSelector from './ModuleSelector';
import TitleSelector from './TitleSelector';
import '../../css/HideOnMobile.css'
import {useLocation} from 'react-router-dom';
import SubtitleSelector from './SubtitleSelector';
import ProviderSelector from "./ProviderSelector";

const Breadcrumbs = () => {
    const location = useLocation()

    const needSubtitle = () => {
        if (location.pathname.includes('/pod') ||
            location.pathname.includes('/control') ||
            location.pathname.includes('/efe/efe') ||
            location.pathname.includes('/admin')) {
            return true
        }

        return false
    }

    return (
        <div style={{ ...styles.center, ...styles.row }}>
            <ModuleSelector />
            <Text style={{ ...styles.marginLeft8, ...styles.marginRight8 }}>/</Text>
            <ProviderSelector />

            <div className='hide-content' >
                <div style={{ ...styles.center, ...styles.row }}>
                    <Text style={{ ...styles.marginLeft8, ...styles.marginRight8 }}>/</Text>
                    <TitleSelector />
                    {needSubtitle() && (
                        <>
                            <Text style={{ ...styles.marginLeft8, ...styles.marginRight8 }}>/</Text>
                            <SubtitleSelector />
                        </>
                    )}
                </div>
            </div>

        </div>
    )
};

export default Breadcrumbs;